import { Component, Input } from '@angular/core';
import { BusinessItem, CoopItem } from '@app/services/logistic.service';
import { OrderHeadGet } from '@app/services/orderhead.service';
import { CustomerItem, TypeaheadService } from '@app/services/typeahead.service';
import { OrderHeadInvoiceFormGroup } from '../../order-head-edit/order-head-edit.component';
import { CustomerEditGet, CustomerService } from '@app/services/customer.service';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'tt-order-head-invoice-address-form',
    templateUrl: './order-head-invoice-address-form.component.html',
    styleUrls: ['./order-head-invoice-address-form.component.css'],
})
export class OrderHeadInvoiceAddressFormComponent {
    @Input()
    public get?: OrderHeadGet;

    @Input()
    public form?: FormGroup<OrderHeadInvoiceFormGroup>;

    @Input()
    public businesses: BusinessItem[] = [];

    @Input()
    public coops: CoopItem[] = [];

    constructor(
        private typeahead: TypeaheadService,
        private customer: CustomerService,
    ) {}

    public searchCustomers = (params?: { [key: string]: any }) => {
        return this.typeahead.searchCustomer({ cust_name: params?.['value'] ?? '', custtype: 'C', lastselect: 'SEARCH' });
    };

    public async onInvoiceCustomerSelected(event?: CustomerItem) {
        this.form?.patchValue({ invoice_cust_no: event?.item_id ?? '0', invoice_cust_name: event?.item_name ?? '' });

        let customer: CustomerEditGet | null = null;

        try {
            if (+(this.form?.controls.invoice_cust_no.value ?? 0) > 0) {
                customer = await this.customer?.getCustomerEdit({ cust_no: this.form?.controls.invoice_cust_no.value ?? '0' });
            }
        } catch (error) {
            console.error(error);
        }

        this.form?.patchValue({
            invoice_cust_no: customer?.cust_no ?? '0',
            invoice_cust_name: customer?.cust_name ?? '',
            invoice_cust_address: customer?.cust_address ?? '',
            invoice_business_id: customer?.cust_business_id ?? '',
            invoice_coop_id: customer?.cust_coop_id ?? '',
        });
    }
}
